/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorResponse from '../model/ErrorResponse';
import FireControllerDevice from '../model/FireControllerDevice';
import FireControllerInformation from '../model/FireControllerInformation';
import FireControllerStatusReport from '../model/FireControllerStatusReport';

/**
* FireController service.
* @module api/FireControllerApi
* @version 1.1.0
*/
export default class FireControllerApi {

    /**
    * Constructs a new FireControllerApi. 
    * @alias module:api/FireControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the fireControllerInformationFireControllerIdDelete operation.
     * @callback module:api/FireControllerApi~fireControllerInformationFireControllerIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerDevice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a Fire Controller Device
     * @param {String} fireControllerId The ID of the Fire Controller to delete
     * @param {module:api/FireControllerApi~fireControllerInformationFireControllerIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerDevice}
     */
    fireControllerInformationFireControllerIdDelete(fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling fireControllerInformationFireControllerIdDelete");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = FireControllerDevice;
      return this.apiClient.callApi(
        '/fire-controller/information/{fireControllerId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerInformationFireControllerIdGet operation.
     * @callback module:api/FireControllerApi~fireControllerInformationFireControllerIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerDevice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a Fire Controller Device by its ID
     * @param {String} fireControllerId The Fire Controller ID of the device to retrieve
     * @param {module:api/FireControllerApi~fireControllerInformationFireControllerIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerDevice}
     */
    fireControllerInformationFireControllerIdGet(fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling fireControllerInformationFireControllerIdGet");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = FireControllerDevice;
      return this.apiClient.callApi(
        '/fire-controller/information/{fireControllerId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerInformationFireControllerIdPatch operation.
     * @callback module:api/FireControllerApi~fireControllerInformationFireControllerIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerDevice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing entry of Fire Controller Information
     * Partially updates a fire controller device. Two independent update paths are supported and may be combined in a single request: **Coordinates (latitude/longitude):** May be supplied directly (e.g., for remote or off-grid locations with no postal address). Explicit values always take precedence over geocoding — if provided, geocoding is skipped. **Address:** If an address is provided without explicit coordinates, geocoding is triggered and the five core address fields are all required: street_addr, city_addr, state_province_addr, postal_code_addr, country_addr (street2_addr is always optional). If geocoding fails, coordinates are stored as null. If explicit coordinates are also provided, the address fields may be partial (they are stored for display only). If neither address nor coordinates are provided, no update is made to those fields. 
     * @param {String} fireControllerId The ID of the Fire Controller to update
     * @param {module:model/FireControllerInformation} fireControllerInformation The information describing the Fire Controller
     * @param {module:api/FireControllerApi~fireControllerInformationFireControllerIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerDevice}
     */
    fireControllerInformationFireControllerIdPatch(fireControllerId, fireControllerInformation, callback) {
      let postBody = fireControllerInformation;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling fireControllerInformationFireControllerIdPatch");
      }
      // verify the required parameter 'fireControllerInformation' is set
      if (fireControllerInformation === undefined || fireControllerInformation === null) {
        throw new Error("Missing the required parameter 'fireControllerInformation' when calling fireControllerInformationFireControllerIdPatch");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FireControllerDevice;
      return this.apiClient.callApi(
        '/fire-controller/information/{fireControllerId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerPUT operation.
     * @callback module:api/FireControllerApi~fireControllerPUTCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerDevice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add new Fire Controller information
     * @param {module:model/FireControllerDevice} fireControllerDevice Fire Controller IDs to associate
     * @param {module:api/FireControllerApi~fireControllerPUTCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerDevice}
     */
    fireControllerPUT(fireControllerDevice, callback) {
      let postBody = fireControllerDevice;
      // verify the required parameter 'fireControllerDevice' is set
      if (fireControllerDevice === undefined || fireControllerDevice === null) {
        throw new Error("Missing the required parameter 'fireControllerDevice' when calling fireControllerPUT");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FireControllerDevice;
      return this.apiClient.callApi(
        '/fire-controller/information', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAllFireControllerStatuses operation.
     * @callback module:api/FireControllerApi~getAllFireControllerStatusesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FireControllerStatusReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all fire controller statuses with location data
     * @param {module:api/FireControllerApi~getAllFireControllerStatusesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FireControllerStatusReport>}
     */
    getAllFireControllerStatuses(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FireControllerStatusReport];
      return this.apiClient.callApi(
        '/fire-controller/status/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserFireControllerStatuses operation.
     * @callback module:api/FireControllerApi~getUserFireControllerStatusesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FireControllerStatusReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get fire controller statuses for a specific user
     * @param {String} userId The unique identifier of the user
     * @param {module:api/FireControllerApi~getUserFireControllerStatusesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FireControllerStatusReport>}
     */
    getUserFireControllerStatuses(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUserFireControllerStatuses");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FireControllerStatusReport];
      return this.apiClient.callApi(
        '/fire-controller/status/{userId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
